import toast from "react-hot-toast";
import { AlertSnackbar } from "ui/pages/snackbar/AlertSnackbar";
import { SubscriptionSnackbar } from "ui/pages/snackbar/SubscriptionSnackbar";
import { DownloadActivitySnackbar } from "ui/pages/snackbar/DownloadActivitySnackbar";

export class Snackbar {
  static async showSuccess({
    title,
    text,
    variant,
    type = "success",
  }: {
    title: string;
    text?: string;
    variant?: "primary" | "secondary";
    type?: "success" | "download";
  }) {
    return toast.custom(
      (t) => (
        <AlertSnackbar
          type={type}
          title={title}
          text={text}
          t={t}
          variant={variant}
        />
      ),
      { duration: 4000 }
    );
  }

  static async showError({ title, text }: { title: string; text?: string }) {
    return toast.custom(
      (t) => <AlertSnackbar type="error" title={title} text={text} t={t} />,
      { duration: 4000 }
    );
  }

  static async showSuggestion({
    duration,
    onClose,
    title,
    text,
    id,
    onNoLongerDisplayed,
    type = "suggestion",
  }: {
    duration?: number | typeof Infinity;
    onClose: () => void;
    title: string;
    text?: string;
    id: string;
    onNoLongerDisplayed?: () => void;
    type?: "success" | "error" | "suggestion";
  }) {
    return toast.custom(
      (t) => (
        <AlertSnackbar
          type={type}
          title={title}
          text={text}
          t={t}
          onClose={onClose}
          onNoLongerDisplayed={onNoLongerDisplayed}
        />
      ),
      { duration, id }
    );
  }

  static async removeSuggestion(id: string) {
    return toast.remove(id);
  }
  static async showSubscriptionAlert(
    onClickNavigate: () => void,
    type:
      | "seance"
      | "technique"
      | "create-seance"
      | "tutorial"
      | "visual-support"
      | "ai-search"
  ) {
    return toast.custom(
      (t) => (
        <SubscriptionSnackbar
          t={t}
          onClickNavigate={onClickNavigate}
          type={type}
        />
      ),
      {
        duration: 6000,
        id: "subscription",
      }
    );
  }

  static async removeSubscriptionAlert() {
    return toast.remove("subscription");
  }

  static async showDownloadActivityAlert(onClickNavigate: () => void) {
    return toast.custom(
      (t) => (
        <DownloadActivitySnackbar t={t} onClickNavigate={onClickNavigate} />
      ),
      {
        duration: 6000,
        id: "download-activity",
      }
    );
  }

  static async removeDownloadActivityAlert() {
    return toast.remove("download-activity");
  }
}
